import Slider from "react-slick";
import "./Team.css";
const TeamCard = () => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="slider-container my-3">
      <Slider {...settings}>
        {team.map((team, key) => {
          return (
            <>
              <div
                className="card team-card shadow mx-3 p-3 text-center"
                key={key}
                data-aos={key % 2 === 0 ? "fade-left" : "fade-right"}
              >
                <div className="text-center mx-auto image">
                  <img
                    src={"/shoyeb" + team?.img}
                    alt="team"
                    className="w-100"
                  />
                </div>
                <div className="text-center text-green mt-4">{team.name}</div>
                <h4>{team.desig}</h4>
                <p>
                  {team.desc.slice(0, 80)}
                  {team.desc.length > 80 && "..."}
                </p>
                <div className="text-center">
                  <a
                    href={team?.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-info fw-bold"
                  >
                    Read more
                  </a>
                </div>
              </div>
            </>
          );
        })}
      </Slider>
    </div>
  );
};

export default TeamCard;
const team = [
  {
    img: "/images/WhatsApp Image 2024-02-11 at 21.19.45_e0afcb1c.jpg",
    name: "Mogis Hussain Hashmi",
    desig: "Frontend  Developer",
    desc: "Mogis Hussain Hashmi is a creative and skilled designer with 2 years of experience",
  },
  {
    img: "/images/hero.png",
    name: "Md Shoyeb",
    link: "https://www.linkedin.com/in/md-shoyeb-49645020a/",
    desig: "Full Stack Developer ",
    desc: "Capable of transforming any idea or logic into code with dynamic responses, backed by 3 years of experience.",
  },
  {
    img: "/images/team3.jpeg",
    name: "Rizwan Ahmad Khan",
    link: "https://www.linkedin.com/in/rizwan-ahmed-khan-731986181/",
    desig: "Software Engineer",
    desc: "He has been employed at Samsung as a software developer for 4 years.",
  },
  {
    img: "/images/team2.jpeg",
    name: "Md Affan Ahmad",
    link: "https://www.linkedin.com/in/md-affan-ahmed-574a851b6/",
    desig: "Android Developer",
    desc: "Affan Ahmad is employed as an Android and R&D engineer at Samsung, with 3 years of experience.",
  },
];
